<!-- =========================================================================================
    File Name: DashboardEcommerce.vue
    Description: Dashboard - Ecommerce
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>

  </div>
</template>

<script>
import "swiper/swiper.min.css";
import "swiper/swiper-bundle.css";
import "swiper/swiper-bundle.min.css"; 
import Store from "../store/store";
import state from "../store/state";

import { Autoplay, Pagination, Navigation } from "swiper";
 

export default {
  setup() {
    return {
      modules: [Autoplay, Pagination, Navigation]
    };
  },
  data() {
    return {
      slide: 0,
      sliding: null,
      dir: false,
      sistemurl: "",
      duyuruList: [],
      haberList: [],
      cariKod: "",

      bannerList: []
    };
  },

  components: {
    
  },

  methods: {

  },
  created() {

  }
};
</script>

<style lang="scss">
.chat-card-log {
  height: 400px;

  .chat-sent-msg {
    background-color: #f2f4f7 !important;
  }
}
</style>
